import L from 'leaflet';

if (!('Geocoder' in L.Control))
	L.Control.Geocoder = {};

L.Control.Geocoder.callbackId = 0;

L.Control.Geocoder.jsonp = function(url, params, callback, context, jsonpParam) {
	var callbackId = '_l_geocoder_' + (L.Control.Geocoder.callbackId++);
	params[jsonpParam || 'callback'] = callbackId;
	window[callbackId] = L.Util.bind(callback, context);
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = url + L.Util.getParamString(params);
	script.id = callbackId;
	document.getElementsByTagName('head')[0].appendChild(script);
};

L.Control.Geocoder.template = function (str, data, htmlEscape) {
	return str.replace(/\{ *([\w_]+) *\}/g, function (str, key) {
		var value = data[key];
		if (value === undefined) {
			value = '';
		} else if (typeof value === 'function') {
			value = value(data);
		}
		return L.Control.Geocoder.htmlEscape(value);
	});
};

// Adapted from handlebars.js
// https://github.com/wycats/handlebars.js/
L.Control.Geocoder.htmlEscape = (function() {
	var badChars = /[&<>"'`]/g;
	var possible = /[&<>"'`]/;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#x27;',
	  '`': '&#x60;'
	};

	function escapeChar(chr) {
	  return escape[chr];
	}

	return function(string) {
		if (string == null) {
			return '';
		} else if (!string) {
			return string + '';
		}

		// Force a string conversion as this will be done by the append regardless and
		// the regex test will do this transparently behind the scenes, causing issues if
		// an object's to string has escaped characters in it.
		string = '' + string;

		if (!possible.test(string)) {
			return string;
		}
		return string.replace(badChars, escapeChar);
	};
})();

L.Control.Geocoder.Nominatim = L.Class.extend({
	options: {
		serviceUrl: '//nominatim.openstreetmap.org/',
		geocodingQueryParams: {},
		reverseQueryParams: {},
		htmlTemplate: function(r) {
			var a = r.address,
				parts = [];
			if (a.road || a.building) {
				parts.push('{building} {road} {house_number}');
			}

			if (a.city || a.town || a.village) {
				parts.push('<span class="' + (parts.length > 0 ? 'leaflet-control-geocoder-address-detail' : '') +
					'">{postcode} {city}{town}{village}</span>');
			}

			if (a.state || a.country) {
				parts.push('<span class="' + (parts.length > 0 ? 'leaflet-control-geocoder-address-context' : '') +
					'">{state} {country}</span>');
			}

			return L.Control.Geocoder.template(parts.join('<br/>'), a, true);
		}
	},

	initialize: function(options) {
		L.Util.setOptions(this, options);
	},

	geocode: function(query, cb, context) {
		L.Control.Geocoder.jsonp(this.options.serviceUrl + 'search/', L.extend({
			q: query,
			limit: 5,
			format: 'json',
			addressdetails: 1
		}, this.options.geocodingQueryParams),
		function(data) {
			var results = [];
			for (var i = data.length - 1; i >= 0; i--) {
				var bbox = data[i].boundingbox;
				for (var j = 0; j < 4; j++) bbox[j] = parseFloat(bbox[j]);
				results[i] = {
					icon: data[i].icon,
					name: data[i].display_name,
					html: this.options.htmlTemplate ?
						this.options.htmlTemplate(data[i])
						: undefined,
					bbox: L.latLngBounds([bbox[0], bbox[2]], [bbox[1], bbox[3]]),
					center: L.latLng(data[i].lat, data[i].lon),
					properties: data[i]
				};
			}
			cb.call(context, results);
		}, this, 'json_callback');
	},

	reverse: function(location, scale, cb, context) {
		L.Control.Geocoder.jsonp(this.options.serviceUrl + 'reverse/', L.extend({
			lat: location.lat,
			lon: location.lng,
			zoom: Math.round(Math.log(scale / 256) / Math.log(2)),
			addressdetails: 1,
			format: 'json'
		}, this.options.reverseQueryParams), function(data) {
			var result = [],
			    loc;

			if (data && data.lat && data.lon) {
				loc = L.latLng(data.lat, data.lon);
				result.push({
					name: data.display_name,
					html: this.options.htmlTemplate ?
						this.options.htmlTemplate(data)
						: undefined,
					center: loc,
					bounds: L.latLngBounds(loc, loc),
					properties: data
				});
			}

			cb.call(context, result);
		}, this, 'json_callback');
	}
});

L.Control.Geocoder.nominatim = function(options) {
	return new L.Control.Geocoder.Nominatim(options);
};
